import { render, staticRenderFns } from "./PlantNew.vue?vue&type=template&id=1447c04c&"
import script from "./PlantNew.vue?vue&type=script&lang=js&"
export * from "./PlantNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports